<template>
  <div class="annotation-list-box">
    <div
      class="list-box"
      v-if="annotationList.length">
      <div
        class="list-item-box"
        v-for="(item, index) in annotationList"
        :key="index">
        <div class="name-box">
          {{ item.name }}
        </div>
        <div :class="getImgListClassName(item.viewPorts)">
          <div
            class="img-item-box"
            v-for="(img, index) in item.viewPorts"
            :key="index"
            @mouseover="handleImgItemMouseOver(img)"
            @mouseleave="handleImgItemMouseLeave"
            @click="handleImgItemClick(img)"
            :style="`background-image:url(${getImgSrc(img.thumbnail)})`" />
        </div>
        <div class="bottom-box">
          <div class="time-box">
            {{ formatTime(item.creationTime) }}
          </div>
          <div class="btn-box">
            <el-button
              type="text"
              size="small"
              title="批注详情"
              @click.stop="openAnnotationDetailsPanel(item)">
              <icon-svg icon-class="icon-xinxi" />
            </el-button>
            <div class="comment-btn-box">
              <el-button
                :class="isAttachmentListVisible(item) ? 'active' : ''"
                type="text"
                size="small"
                title="附件"
                @click.stop="expandAttachmentList(item)">
                <icon-svg icon-class="icon-tianjiafujian" />
              </el-button>
              <div class="count-box">({{ item.attachmentCount }})</div>
            </div>
            <div class="comment-btn-box">
              <el-button
                :class="isCommentVisible(item) ? 'active' : ''"
                type="text"
                size="small"
                title="评论"
                @click.stop="expandCommentList(item)">
                <icon-svg icon-class="icon-pinglun" />
              </el-button>
              <div class="count-box">({{ item.commentCount }})</div>
            </div>
          </div>
        </div>
        <div
          class="attachment-list-box"
          v-if="isAttachmentListVisible(item)">
          <div
            v-for="(attachment, index) in attachmentList"
            :key="index"
            class="attachment-item-box">
            <div class="attachment-info-box">
              <div class="icon-box">
                <img :src="getFileTypeIcon(attachment.attachmentName)" />
              </div>
              <div class="info-box">
                <div
                  class="text-overflow"
                  :title="attachment.attachmentName">
                  {{ attachment.attachmentName }}
                </div>
                <div class="size-box">
                  {{ `(${getFileSize(attachment.fileSize)})` }}
                </div>
              </div>
            </div>
            <div class="attachment-btn-box">
              <el-button
                v-if="isViewAttachmentBtnVisible(attachment)"
                type="text"
                size="small"
                title="查看"
                @click.stop="viewAttachment(attachment)">
                <icon-svg icon-class="icon-chakanxiangqing" />
              </el-button>
              <el-button
                type="text"
                size="small"
                title="下载"
                @click.stop="downloadAttachment(attachment)">
                <icon-svg icon-class="icon-xiazai" />
              </el-button>
            </div>
          </div>
        </div>
        <div
          class="comment-box"
          v-if="isCommentVisible(item)">
          <div
            class="comment-list-box"
            v-if="commentList.length"
            v-infinite-scroll="handleScroll">
            <div
              class="comment-item-box"
              v-for="(comment, index) in commentList"
              :key="index">
              <div class="comment-header-box">
                <div class="user-info-box">
                  <!-- <div class="user-icon-box"></div> -->
                  <div class="user-name-box">{{ comment.creatorName }}</div>
                  <div class="time-info-box">
                    {{ formatTime(comment.creationTime) }}
                  </div>
                </div>
              </div>
              <div class="comment-content-box">
                {{ comment.comment }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="empty-box"
      v-else>
      <div class="tip-box">
        <div class="img-box">
          <img :src="require('@/assets/img/no-params.png')" />
        </div>
        <div class="text-box">
          <span>暂无批注</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTime, formatFileSize } from '@/utils/generalMethods'

import {
  getAnnotationDetailsService,
  getAnnotationAttachmentListService,
  getAnnotationCommentListService
} from '@/service/share/sceneShareInterface.js'

export default {
  data() {
    return {
      // 当前激活的批注，用于控制展示附件和评论
      currActiveAnnotationId: '',
      currActiveType: '',
      attachmentList: [],

      currComment: {
        annotationId: '',
        annotationName: '',
        content: ''
      },
      commentList: [],
      currPage: 1,
      pageSize: 10,
      isAllCommentLoaded: false
    }
  },
  props: {
    annotationList: Array,
    refreshAnnotationList: Function
  },
  methods: {
    handleImgItemMouseOver(viewportInfo) {
      let viewportImg = this.getImgSrc(viewportInfo.thumbnail)
      this.$emit('openViewportImg', viewportImg)
    },
    handleImgItemMouseLeave() {
      this.$emit('closeViewportImg')
    },
    handleImgItemClick(viewportInfo) {
      let visualAngle = JSON.parse(viewportInfo.visualAngle)

      let camLoc = new window.BlackHole3D.REForceCamLoc()
      camLoc.camPos = visualAngle.camPos
      camLoc.camRotate = visualAngle.camRotate
      window.BlackHole3D.Camera.setCamLocateTo(camLoc, 0.5, 1)

      this.$nextTick(() => {
        let viewportImg = this.getImgSrc(viewportInfo.thumbnail)
        this.$emit('openAnnotationViewport', viewportImg)
      })
    },
    openAnnotationDetailsPanel(annotationInfo) {
      this.queryAnnotationDetails(annotationInfo).then(annotationDetails => {
        this.$emit('openAnnotationDetailsPanel', annotationDetails)
      })
    },
    expandAttachmentList(annotationInfo) {
      if (this.currComment.content) {
        let annotationName = this.currComment.annotationName
        this.$message(`${annotationName}正在进行评论，请发布后再查看附件`)
        return
      }

      if (this.isAttachmentExpanded(annotationInfo)) {
        this.currActiveAnnotationId = ''
        this.currComment = {
          annotationId: '',
          annotationName: '',
          content: ''
        }
        return
      }

      this.attachmentList = []
      this.currActiveType = 'attachment'
      this.currComment = {
        annotationId: annotationInfo.sceneAnnotationId,
        annotationName: annotationInfo.name,
        content: ''
      }

      let annotationId = annotationInfo.sceneAnnotationId
      this.currActiveAnnotationId = annotationId
      this.queryAttachmentList(annotationId).then(attachmentList => {
        if (attachmentList.length) {
          this.attachmentList = attachmentList
        } else {
          this.currActiveAnnotationId = ''
          this.$message.warning('当前批注没有附件')
        }
      })
    },
    isAttachmentExpanded(annotationInfo) {
      let annotationId = annotationInfo.sceneAnnotationId
      if (this.currActiveType !== 'attachment') return false

      if (annotationId === this.currActiveAnnotationId) {
        return true
      } else {
        return false
      }
    },
    viewAttachment(attachmentInfo) {
      let fileDataId = attachmentInfo.fileDataId
      let tokenId = this.$route.query.token
      let attachmentUrl = `${window.serverUrl}/${window.downloadUrl}/${fileDataId}?token=${tokenId}`

      const fileTypeMap = [
        {
          typeValue: 'text',
          subTypes: ['txt']
        },
        {
          typeValue: 'document',
          subTypes: ['docx']
        },
        {
          typeValue: 'excel',
          subTypes: ['xls', 'xlsx']
        },
        {
          typeValue: 'pdf',
          subTypes: ['pdf']
        }
      ]
      let fileName = attachmentInfo.attachmentName
      let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      fileType = fileType.toLowerCase()
      let find = fileTypeMap.find(item => item.subTypes.includes(fileType))
      let attachmentType = find.typeValue

      const routerUrl = this.$router.resolve({
        path: `../../../attachmentView`,
        query: { attachmentType, attachmentUrl }
      })

      window.open(routerUrl.href, '_blank')
    },
    downloadAttachment(attachmentInfo) {
      let url = ''
      let fileDataId = attachmentInfo.fileDataId
      let tokenId = this.$route.query.token
      if (window.downloadUrl.includes('http')) {
        url = `${window.downloadUrl}/${fileDataId}?token=${tokenId}`
      } else {
        url = `${window.serverUrl}/${window.downloadUrl}/${fileDataId}?token=${tokenId}`
      }

      this.downloadURL(url, 1)
    },
    downloadURL(url, id) {
      let hiddenIFrameID = 'hiddenDownloader' + id
      let iframe = document.createElement('iframe')
      iframe.id = hiddenIFrameID
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
      iframe.src = url
    },
    expandCommentList(annotationInfo) {
      if (this.currComment.content) {
        let annotationName = this.currComment.annotationName
        this.$message(`${annotationName}正在进行评论，请发布后再查看评论`)
        return
      }

      if (this.isCommentExpanded(annotationInfo)) {
        this.currActiveAnnotationId = ''
        this.currComment = {
          annotationId: '',
          annotationName: '',
          content: ''
        }
        return
      }

      this.commentList = []
      this.currActiveType = 'comment'

      let annotationId = annotationInfo.sceneAnnotationId
      this.currActiveAnnotationId = annotationId
      this.currPage = 1
      this.queryCommentList().then(commentList => {
        this.commentList = commentList
      })
    },
    isCommentExpanded(annotationInfo) {
      let annotationId = annotationInfo.sceneAnnotationId
      if (this.currActiveType !== 'comment') return false

      if (annotationId === this.currActiveAnnotationId) {
        return true
      } else {
        return false
      }
    },
    handleScroll() {
      // 防止每次重新渲染都会触发滚动事件
      if (this.commentList.length < this.pageSize) return

      if (this.isAllCommentLoaded) return
      this.currPage++
      this.queryCommentList().then(commentList => {
        if (commentList.length) {
          this.commentList = [...this.commentList, ...commentList]
        } else {
          this.isAllCommentLoaded = true
        }
      })
    },
    queryAttachmentList(annotationId) {
      return new Promise(resolve => {
        let headers = this.getHeaders()
        getAnnotationAttachmentListService(annotationId, headers).then(
          response => {
            if (response.isSuccess) {
              let attachmentList = response.data
              resolve(attachmentList)
            } else {
              this.$message.error(response.errMsg)
            }
          }
        )
      })
    },
    queryCommentList() {
      return new Promise(resolve => {
        let params = {
          sceneAnnotationId: this.currActiveAnnotationId,
          resultCount: this.pageSize,
          skipCount: (this.currPage - 1) * this.pageSize
        }
        let headers = this.getHeaders()
        getAnnotationCommentListService(params, headers).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let commentList = data.items
            resolve(commentList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    queryAnnotationDetails(annotationInfo) {
      return new Promise(resolve => {
        let annotationId = annotationInfo.sceneAnnotationId
        let headers = this.getHeaders()
        getAnnotationDetailsService(annotationId, headers).then(response => {
          if (response.isSuccess) {
            let data = response.data
            resolve(data)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    isCommentVisible(annotationInfo) {
      let annotationId = annotationInfo.sceneAnnotationId
      let isActiveAnnotation = this.currActiveAnnotationId === annotationId
      let isActiveType = this.currActiveType === 'comment'
      if (isActiveAnnotation && isActiveType) {
        return true
      } else {
        return false
      }
    },
    isAttachmentListVisible(annotationInfo) {
      let annotationId = annotationInfo.sceneAnnotationId
      let isActiveAnnotation = this.currActiveAnnotationId === annotationId
      let isActiveType = this.currActiveType === 'attachment'
      let isExistAttachment = this.attachmentList.length > 0
      if (isActiveAnnotation && isActiveType && isExistAttachment) {
        return true
      } else {
        return false
      }
    },
    isViewAttachmentBtnVisible(attachmentInfo) {
      let fileName = attachmentInfo.attachmentName
      let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      fileType = fileType.toLowerCase()

      const visibleFileTypes = ['docx', 'xls', 'xlsx', 'pdf', 'txt']
      return visibleFileTypes.includes(fileType)
    },
    getImgListClassName(thumbnails) {
      let className = 'img-list-box'
      if (thumbnails.length === 1) {
        className += ' single-img-list'
      } else {
        className += ' muti-img-list'
      }
      return className
    },
    getImgSrc(thumbnailSrc) {
      let imgSrc = `${window.imageBaseUrl}/${thumbnailSrc}`
      return imgSrc
    },
    getFileTypeIcon(fileName) {
      let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      fileType = fileType.toLowerCase()

      let imgSrc = ''
      switch (fileType) {
        case 'doc':
          imgSrc = require('@/assets/icon/doc.png')
          break
        case 'docx':
          imgSrc = require('@/assets/icon/doc.png')
          break
        case 'xls':
          imgSrc = require('@/assets/icon/xls.png')
          break
        case 'xlsx':
          imgSrc = require('@/assets/icon/xls.png')
          break
        case 'pdf':
          imgSrc = require('@/assets/icon/pdf.png')
          break
        case 'txt':
          imgSrc = require('@/assets/icon/txt.png')
          break
        case 'zip':
          imgSrc = require('@/assets/icon/zip.png')
          break
        default:
          imgSrc = require('@/assets/icon/png.png')
          break
      }

      return imgSrc
    },
    getFileSize(fileSize) {
      let size = formatFileSize(fileSize).fileSize
      let unit = formatFileSize(fileSize).unit
      let fileSizeStr = `${size}${unit}`
      return fileSizeStr
    },
    getHeaders() {
      let token = this.$route.query.token
      let headers = {
        Authorization: token
      }
      return headers
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.annotation-list-box {
  flex-grow: 1;
  overflow: hidden;
  .list-box {
    padding: 8px 0px;
    font-size: 14px;
    height: 100%;
    overflow-y: auto;

    .list-item-box {
      margin-bottom: 8px;
      padding: 8px;
      border-radius: 8px;
      border: 1px solid var(--annotation-list-border-color);

      &:last-child {
        margin-bottom: 0px;
      }

      .name-box {
        font-weight: 400;
        line-height: 22px;
        text-align: left;
      }

      .img-list-box {
        display: grid;
        gap: 10px;

        &.single-img-list {
          grid-template-columns: repeat(1, 1fr);

          .img-item-box {
            height: 176px;
            cursor: pointer;
          }
        }

        &.muti-img-list {
          grid-template-columns: repeat(3, 1fr);

          .img-item-box {
            height: 56px;
            cursor: pointer;
          }
        }

        .img-item-box {
          border-radius: 6px;
          background-size: cover;
          background-position: center;
        }
      }

      .bottom-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 4px;

        .time-box {
          font-weight: 400;
          font-size: 14px;
          color: var(--viewport-text-color);
        }

        .btn-box {
          display: flex;
          align-items: center;

          .comment-btn-box {
            display: flex;

            .count-box {
              color: var(--base-primary-bgColor);
            }
          }

          .el-button--text {
            margin-left: 0px;
            color: var(--anchor-list-text-icon-color);
            padding: 2px;

            &:hover {
              color: var(--base-primary-bgColor);
              background: var(--base-bg-light-color77);
            }

            &.active {
              color: var(--base-primary-bgColor);
              background: var(--base-bg-light-color77);
            }
          }
        }
      }

      .attachment-list-box {
        font-size: 14px;
        .attachment-item-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 4px 0px;
          padding: 5px 8px;
          border-radius: 8px;
          background: var(--attachment-bg-color);
          border: 1px solid var(--attachment-border-color);

          .attachment-info-box {
            display: flex;
            align-items: center;
            overflow: hidden;

            .icon-box {
              img {
                vertical-align: bottom;
              }
            }

            .info-box {
              display: flex;
              align-items: center;
              margin-left: 5px;
              margin-right: 15px;
              color: var(--attachment-normal-color);
              overflow: hidden;

              .size-box {
                margin-left: 5px;
              }
            }
          }

          .attachment-btn-box {
            display: flex;
            align-items: center;
            flex-shrink: 0;

            .el-button--text {
              margin-left: 0px;
              color: var(--attachment-normal-color);
              padding: 2px;

              &:hover {
                background: var(--base-bg-dark-color33);
              }
            }
          }
        }
      }

      .comment-box {
        .comment-input-box {
          display: flex;
          align-items: center;

          .publish-icon-box {
            margin-left: 5px;
            color: var(--base-primary-bgColor);
            background: var(--base-bg-light-color77);
            cursor: pointer;
          }
        }

        .comment-list-box {
          margin-top: 8px;
          max-height: 300px;
          overflow-y: auto;

          .comment-item-box {
            margin: 4px 0px;
            padding: 6px;
            border-radius: 6px;
            background: var(--comment-bg-color);

            .comment-header-box {
              display: flex;
              align-items: center;
              justify-content: space-between;

              .user-info-box {
                display: flex;
                align-items: center;

                .user-name-box {
                  font-size: 14px;
                  color: var(--comment-user-color);
                }

                .time-info-box {
                  margin-left: 8px;
                  color: var(--comment-time-color);
                  font-size: 12px;
                }
              }

              .close-icon-box {
                display: flex;
                color: var(--comment-icon-color);
                cursor: pointer;
                padding: 5px;
                border-radius: 4px;

                &:hover {
                  background: var(--comment-icon-hover-color);
                }
              }
            }

            .comment-content-box {
              margin-top: 6px;
              text-align: left;
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  .empty-box {
    display: flex;
    height: 100%;

    .tip-box {
      margin: auto;
      font-size: 12px;
      color: var(--viewport-btn-empty-text-color);

      .text-box {
        width: 200px;
        margin: auto;
        line-height: 22px;
      }

      .bold-text-box {
        font-weight: bold;
        color: var(--viewport-btn-empty-bold-text-color);
      }
    }
  }
}
</style>
